/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultGeomatique } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_004: Question = {
  id: 'pres-004-superficie-spcv',
  oldId: '18',
  title: 'Superficie des sites protégés par la conservation volontaire (SPCV) non reconnus au RAPQ',
  number: '2.4',
  description: [''],
  type: QuestionType.INDICATOR,
  frequency: 3,
  slots: [
    {
      type: SlotTypes.GEOMATIQUE,
      items: ['Superficie des sites protégés par la conservation volontaire (SPCV) non reconnus au RAPQ en hectares'],
      data: ['0'],
      scoreCalculatedLater: true,
      optional: false,
      scoringFct: (data: string[]) => data,
      score: '0',
      help: defaultGeomatique,
      unit: SlotUnit.HECTARE,
    },
  ],
};

const question_pres_004__v3: Question = {
  ...question_pres_004,
  frequency: 2,
};

export const question_pres_004_v2: Question = question_pres_004;
export const question_pres_004_v3: Question = question_pres_004__v3;
